import { useState, useEffect } from "react"
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  FormGroup,
  Col,
  Form,
  Button,
  Label,
  InputGroup
} from "reactstrap"
import { jwtDecode } from "jwt-decode"
import InputPasswordToggle from "../CustomComponent/input-toggle"

import { toast } from "react-toastify"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { postUpdatePassword } from "../../services/endpointUtils/auth"
import AuthLogout from "../../services/endpointUtils/logout"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { setIsAcess } from "../../redux/actions"

const MySwal = withReactContent(Swal)

const UpdatePassword = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //  password state
  const [formValues, setFormValues] = useState({
    old_pass: "",
    password: "",
    password2: ""
  })

  // Api to Post to update user password

  const updatePassword = async (data) => {
    postUpdatePassword({
      ...formValues,
      email: jwtDecode(localStorage.getItem("accessToken")).userData.email
    })
      .then((response) => {
        console.log(response?.response?.data?.responseCode)
        if (response?.data?.responseCode === 202 || response?.data?.responseCode === 200) {
          MySwal.fire({
            icon: "success",
            title: "Please notice !",
            text: `${response?.data?.data?.result?.success}`,
            customClass: {
              confirmButton: "btn btn-success"
            }
          }).then((result) => {
            if (result.isConfirmed) {
              setFormValues(response)
              dispatch(setIsAcess(false))
              localStorage.clear()
              navigate("/")
            }
          })
        } else if (response?.response?.data?.responseCode === 406) {
          const { error } = response?.response?.data?.data || {}

          const swalConfig = {
            icon: "error",
            title: "Failed!",
            customClass: {
              confirmButton: "btn btn-danger"
            }
          }

          if (error?.detail) {
            swalConfig.text = error.detail
          } else if (error?.message) {
            swalConfig.text = error.message
          } else if (error?.password) {
            swalConfig.html = error.password.map((msg) => `<p>${msg}</p>`).join("")
          }

          MySwal.fire(swalConfig)
        } else {
          toast.error("Something went wrong.", {
            hideProgressBar: true
          })
        }
      })
      .catch((e) => {
        console.log(e)
      })

    // Handle error
  }

  //  to show sweet alert to confirm update password
  const handleConfirmText = () => {
    return MySwal.fire({
      text: `Are you sure want want to update it`,
      title: "Are you sure !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-outline-danger ml-1"
      },
      buttonsStyling: false
    }).then(function (result) {
      // console.log()
      if (result.value) {
        updatePassword()
      }
    })
  }

  // on change function
  const onChangePassword = (event) => {
    const name = event.target.name
    const value = event.target.value
    setFormValues((values) => ({ ...values, [name]: value }))
  }

  return (
    <Card style={{ border: "none", boxShadow: "none", marginBottom: "16px" }}>
      <CardHeader className='card_header'>
        <CardTitle tag='h4'>New Password</CardTitle>
      </CardHeader>
      <CardBody>
        <Form
          // on submit form
          onSubmit={(e) => {
            e.preventDefault()
            //  To validate password
            if (formValues.password === formValues.password2) {
              handleConfirmText()
            } else {
              toast.error(" Re-check Password .", {
                hideProgressBar: true
              })
            }
          }}
        >
          <FormGroup row>
            <Label sm='4' for='old_pass'>
              Old Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='old_pass'
                  name='old_pass'
                  className='input-group-merge'
                  value={formValues.old_pass}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='4' for='password'>
              New Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='password'
                  name='password'
                  className='input-group-merge'
                  value={formValues.password}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label sm='4' for='password2'>
              Confirm New Password
            </Label>
            <Col sm='8'>
              <InputGroup className='input-group-merge'>
                <InputPasswordToggle
                  id='password2'
                  name='password2'
                  className='input-group-merge'
                  value={formValues.password2}
                  onChange={onChangePassword}
                  required
                />
              </InputGroup>
            </Col>
          </FormGroup>

          <FormGroup className='mb-0 ' row>
            <Col className='d-flex gap-3' md={{ size: 9, offset: 3 }}>
              <Button className='mr-1' color='primary' type='submit'>
                Submit
              </Button>
              {/* On reset the form */}
              <Button
                outline
                color='secondary'
                type='reset'
                onClick={(e) => {
                  setFormValues("")
                }}
              >
                Reset
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  )
}
export default UpdatePassword
